import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import SignIn from './page';
import HideForms from '../../components/SendPulseForms/hide';


const Auth = () => {
    return (
        <>
            <HideForms />
            <GoogleReCaptchaProvider reCaptchaKey="6LfGhr4qAAAAALrY3Uv79yu-B1Jara38eQB1aB0R">
                <SignIn />
            </GoogleReCaptchaProvider>
        </>
    )
}

export default Auth;